const OverlayStyle = (theme) => ({
  overlayHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(4),
  },
  overlayTitle: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.grey[800],
    textTransform: 'uppercase',
  },
  closeIcon: {
    width: theme.spacing(3),
    height: theme.spacing(4),
    color: theme.palette.grey[600],

  },
});

export default OverlayStyle;
